var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "#FFF",
    strokeWidth: 1,
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hinta-/-Desktop",
    transform: "translate(-57.000000, -43.000000)",
    fill: "#FFEDB9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(57.000000, 43.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.83262392,3.09249239 C4.24342873,3.09249239 3.76575672,2.61595837 3.76575672,2.02562519 L3.76575672,1.0668672 C3.76575672,0.477956506 4.24342873,-1.0421104e-13 4.83262392,-1.0421104e-13 C5.42181911,-1.0421104e-13 5.89949112,0.477956506 5.89949112,1.0668672 L5.89949112,2.02562519 C5.89949112,2.61595837 5.42181911,3.09249239 4.83262392,3.09249239",
    id: "Fill-244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.83262392,9.66581683 C4.24342873,9.66581683 3.76575672,9.18786033 3.76575672,8.59894963 L3.76575672,7.64019164 C3.76575672,7.05128095 4.24342873,6.57332444 4.83262392,6.57332444 C5.42181911,6.57332444 5.89949112,7.05128095 5.89949112,7.64019164 L5.89949112,8.59894963 C5.89949112,9.18786033 5.42181911,9.66581683 4.83262392,9.66581683",
    id: "Fill-245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02534069,5.90048686 L1.0668672,5.90048686 C0.477672008,5.90048686 -4.7002402e-14,5.42253036 -4.7002402e-14,4.83361966 C-4.7002402e-14,4.24470897 0.477672008,3.76675246 1.0668672,3.76675246 L2.02534069,3.76675246 C2.61453588,3.76675246 3.09220789,4.24470897 3.09220789,4.83361966 C3.09220789,5.42253036 2.61453588,5.90048686 2.02534069,5.90048686",
    id: "Fill-246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59838064,5.90048686 L7.63976489,5.90048686 C7.0505697,5.90048686 6.57289769,5.42253036 6.57289769,4.83361966 C6.57289769,4.24470897 7.0505697,3.76675246 7.63976489,3.76675246 L8.59838064,3.76675246 C9.18757583,3.76675246 9.66524784,4.24470897 9.66524784,4.83361966 C9.66524784,5.42253036 9.18757583,5.90048686 8.59838064,5.90048686",
    id: "Fill-247"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.4a145e05a36e1c354804c3cf290e1a7e.svg";
export { ForwardRef as ReactComponent };